import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import {
  FlippingTileComponent,
  FlippingTilesComponent,
  FlippingTilesVariant,
} from '@knorr-bremse-portals/ngx-components/components/flipping-tiles';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';

import { PlainImageSection, imageToPicture } from '../../components/plain-image/plain-image.component';
import { SectionComponent } from '../../components/section/section.component';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';
import { EditorIdDirective } from '../../directives/editor-id.directive';
import { InnerSection, Section, SectionAttributes } from '../../types/section';

type FlippingTileSection = InnerSection<
  {
    headline: string;
    text: string;
    image?: PlainImageSection;
  },
  [
    'headline',
    'text',
    'image',
  ],
  'flipping-tile'
>;

type FlippingTilesSection = Section<
  {
    numColumns: 12;
    headline?: string;
    content?: string;
    items: FlippingTileSection[];
    variant?: FlippingTilesVariant;
  } & SectionAttributes,
  [
    'headline',
    'content',
    'items',
    'variant',
  ],
  'flipping-tiles'
>;

@Component({
    selector: 'section[app-flipping-tiles]',
    templateUrl: './flipping-tiles.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        FlippingTilesComponent,
        FlippingTileComponent,
        HtmlComponent,
        PictureComponent,
        FsButtonComponent,
    ],
})
export class FlippingTilesSectionComponent extends SectionComponent<FlippingTilesSection> {
  protected imageToPicture = imageToPicture;
  protected squareAspectRatio = AspectRatio.Square;
  protected pictureVariants = [{
    aspectRatio: this.squareAspectRatio,
  }];
}
